import { render, staticRenderFns } from "./wholesaler.vue?vue&type=template&id=f67e0d6e&scoped=true&"
import script from "./wholesaler.vue?vue&type=script&lang=js&"
export * from "./wholesaler.vue?vue&type=script&lang=js&"
import style0 from "./wholesaler.vue?vue&type=style&index=0&id=f67e0d6e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.7.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f67e0d6e",
  null
  
)

export default component.exports